import { Routes } from "@angular/router";

import { AuthGuard } from "src/app/_helpers/auth.guard";
import { DefaultAddComponent } from "src/app/commons/default-add/default-add.component";
import { DefaultEditComponent } from "src/app/commons/default-edit/default-edit.component";
import { RoleGuard } from "src/app/_helpers/role.guard";
import { DashboardComponent } from "src/app/pages/commons/dashboard/dashboard.component";
import { UserProfileComponent } from "src/app/pages/commons/user-profile/user-profile.component";
import { StudiosComponent } from "src/app/pages/manager-studio/studios/studios.component";
import { ReservationsComponent } from "src/app/pages/manager-studio/reservations/reservations.component";
import { ContactComponent } from "src/app/pages/commons/contact/contact.component";
import { ReservationInfoComponent } from "src/app/pages/manager-studio/reservation-info/reservation-info.component";
import { MesReservationsComponent } from "src/app/pages/artist/mes-reservations/mes-reservations.component";
import { MaReservationDetailsComponent } from "src/app/pages/artist/ma-reservation-details/ma-reservation-details.component";
import { MesFacturesComponent } from "src/app/pages/artist/mes-factures/mes-factures.component";
import { MonPlanningComponent } from "src/app/pages/manager-studio/mon-planning/mon-planning.component";
import { PlanningBookingComponent } from "src/app/pages/artist/planning-booking/planning-booking.component";
import { PaymentFormComponent } from "src/app/pages/artist/payment-form/payment-form.component";
import { PaymentSuccessComponent } from "src/app/pages/artist/payment-success/payment-success.component";
import { PaymentCancelComponent } from "src/app/pages/artist/payment-cancel/payment-cancel.component";
import { PasscultureHistoriquesComponent } from "src/app/pages/manager-studio/passculture-historiques/passculture-historiques.component";
import { OpeningSlotsComponent } from "src/app/pages/manager-studio/opening-slots/opening-slots.component";

export const AdminLayoutRoutes: Routes = [
  // commons
  { path: "dashboard", component: DashboardComponent },
  { path: "contact", component: ContactComponent },
  {
    path: "user-profile",
    component: UserProfileComponent,
    canActivate: [AuthGuard],
  },
  // artist
  {
    path: "mes-reservations",
    component: MesReservationsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "artist" },
  },
  {
    path: "mes-reservations/info/:id",
    component: MaReservationDetailsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "artist" },
  },
  {
    path: "mes-factures",
    component: MesFacturesComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "artist" },
  },
  { path: "planning-booking", component: PlanningBookingComponent },
  { path: "payment-form", component: PaymentFormComponent },
  {
    path: "payment-success",
    component: PaymentSuccessComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "artist" },
  },
  {
    path: "payment-cancel",
    component: PaymentCancelComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "artist" },
  },
  // manager studio
  {
    path: ":endpoint/ajouter",
    component: DefaultAddComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "manager_studio" },
  },
  {
    path: ":endpoint/edit/:id",
    component: DefaultEditComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "manager_studio" },
  },
  {
    path: "reservations/info/:id",
    component: ReservationInfoComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "manager_studio" },
  },
  {
    path: "studios",
    component: StudiosComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "manager_studio" },
  },
  {
    path: "studios/:id/opening-slots",
    component: OpeningSlotsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "manager_studio" },
  },
  {
    path: "reservations",
    component: ReservationsComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "manager_studio" },
  },
  {
    path: "mon-planning",
    component: MonPlanningComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "manager_studio" },
  },
  {
    path: "passculture-historiques",
    component: PasscultureHistoriquesComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { role: "manager_studio" },
  },
];
